import { ButtonV2 } from '@asigna/kit';
import cx from 'classnames';
import { ModalCloseButton } from 'components';

import accImage from './utils/images/accounts.png';

import s from './index.module.scss';

interface Props {
  id?: string;
  onClose: () => void;
  onSuccess: () => void;
}

export const AsignaProSubAccountsDialog = (props: Props) => {
  const { onClose, onSuccess } = props;

  return (
    <div className="flex flex-col gap-16 relative">
      <div
        className={cx(
          s.header,
          'flex items-center justify-center mx-[-24px] mt-[-24px] overflow-hidden'
        )}
      >
        <img src={accImage} alt="" className="mt-32" />
      </div>
      <div className="absolute top-0 right-0">
        <ModalCloseButton onClick={onClose} />
      </div>

      <div className="flex flex-col items-center ">
        <div className="flex items-center gap-4 mb-12">
          <span className="text-m13 text-regular">Asigna</span>
          <div className="text-center font-bold text-[13px] leading-[20px] text-black-0 w-[43px] h-24 rounded-[12px] bg-regular flex items-center justify-center">
            Pro
          </div>
        </div>
        <div className="text-center mb-8 text-r24 font-black">
          Unlock sub-accounts and advanced multisig capabilities with Asigna Pro!
        </div>
        <div className="text-r14 text-regular text-center mb-32">
          This feature is exclusively available with Asigna Pro. Upgrade now to unlock your wallet's
          full potential and streamline your workflow.
        </div>

        <ButtonV2
          className={cx(
            'mt-4 w-[200px] transition-all',
            'bg-[linear-gradient(103deg,_#FFE341_0%,_#F7E47D_24.5%,_#F1C855_48.99%,_#FFE2A8_73.49%,_#FFE970_97.99%)]',
            'hover:bg-[linear-gradient(104deg,_#FFE341_0%,_#F7E47D_35.79%,_#F1C855_71.57%,_#FFE2A8_107.36%,_#FFE970_143.14%)]'
          )}
          onClick={onSuccess}
        >
          <span className="text-[#493B15] font-extrabold">Upgrade to Pro</span>
        </ButtonV2>
      </div>
    </div>
  );
};
